



















import LicenseExpiryInfo from '@/components/LicenseExpiryInfo'
import ListButton from '@/components/shared/ListButton'
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  components: {
    LicenseExpiryInfo: LicenseExpiryInfo,
    ListButton: ListButton
  },
  computed: mapState('environment', [
    'chromeKioskModeDetected',
  ])
})
export default class Home extends Vue {

  private chromeKioskModeDetected!: boolean

  mounted () {
    this.$store.dispatch ('settings/loadSettings')
  }

  private exitKiosk() {
    // This functionality is dependent on Chrome extension "Exit Kiosk" with default keyword 'exitkiosk' set for exiting
    // https://chromewebstore.google.com/detail/exit-kiosk/hapjpnffclfahpkcmcnohjcklfnocpmf
    window.location.href = '#exitkiosk'
  }

}
